import {ResponsiveContent} from "../../../ResponsiveNavTabs";
import React, {useRef, useState} from "react";
import {Button, ListGroup, Stack} from "react-bootstrap";
import {Link} from "react-router-dom";
import {
    useCarrier,
    useCarrierCount,
    useLongPress,
    useCarrierList, useCarrierOrderOptions,
    useLocalFilter2,
    useSelect,
    useTouch
} from "../../../../hooks";
import {useAlert, useAuth} from "../../../../context";
import {ItemLoading} from "../../../_components";
import {OurPagination2} from "../../../_components";
import {OurClearAlert} from "../../../_components";
import {MenuAdd, MenuBar, MenuClearSelectButton, MenuConfirmDeleteButton, MenuOrderBy, MenuSearchTerm, PageTitle} from "../../../_components";

export function Carriers() {
    return <ResponsiveContent body={<CarrierForm/>}/>
}

function CarrierForm() {
    const {userId} = useAuth()
    const {success} = useAlert()

    // Get order options
    const {orderOptions, errorOrderOptions, clearErrorOrderOptions} = useCarrierOrderOptions()

    // API Actions
    const {deleteItem, errorValue, clearErrorValue} = useCarrier(userId)

    // API count all items
    const {count, setCount, loadingCount, errorCount, clearErrorCount} = useCarrierCount()

    // API items per page
    const {list, setList, loadingList, errorList, clearErrorList} = useCarrierList(10)

    // Filter
    const filteredList = useLocalFilter2(list, ["name", "company"])

    // Select
    const [selList, toggleSelectItems, clearSelectItems, isItemSelected] = useSelect(list)


    function handleOnItemsDelete() {
        selList
            .forEach(item =>
                deleteItem(item.id)
                    .then(() => {
                        setCount(count => count - 1)
                        setList(prev => prev.filter(obj => obj.id !== item.id))
                        success(`${item.name} has been deleted!`)
                    })
                    .catch(err => console.warn(err.message))
            )
        clearSelectItems()
    }


    return <Stack>

        <OurClearAlert variant="danger" msg={errorOrderOptions} onClear={clearErrorOrderOptions}/>
        <OurClearAlert variant="danger" msg={errorCount} onClear={clearErrorCount}/>
        <OurClearAlert variant="danger" msg={errorList} onClear={clearErrorList}/>
        <OurClearAlert variant="danger" msg={errorValue} onClear={clearErrorValue}/>

        <PageTitle title="Carriers">Manage {list.length} of {count} carriers.</PageTitle>

        <MenuBar>
            <MenuAdd to="/backend/carrier/add" icon="plus">Add</MenuAdd>
            <MenuSearchTerm/>
            <MenuOrderBy orderOptions={orderOptions}/>
            <MenuClearSelectButton hide={selList.length === 0} onClick={clearSelectItems}>
                {selList.length} {selList.length === 1 ? "row" : "rows"}
            </MenuClearSelectButton>
            <MenuConfirmDeleteButton hide={selList.length === 0} onSubmit={handleOnItemsDelete}>
                <span>{selList.length} {selList.length === 1 ? "carrier" : "carriers"}</span>
            </MenuConfirmDeleteButton>
        </MenuBar>

        <ItemLoading show={loadingCount || loadingList}/>

        {list && list.length > 0 ?
            <ListGroup variant="flush">
                {filteredList.map(item =>
                    <RenderItem key={item.id} item={item} selected={isItemSelected(item.id)} selectedCount={selList.length} onSelect={toggleSelectItems}
                                to={`/backend/carrier/${item.id}`}/>
                )}
            </ListGroup>
            :
            <span className="text-center">No carrier added yet</span>
        }

        <OurPagination2 loading={loadingCount || loadingList} itemCount={count}/>

    </Stack>
}

function RenderItem({item, selected, selectedCount, onSelect, to}) {
    const touch = useTouch()
    const [show, setShow] = useState(false)

    const ref = useRef(null)
    useLongPress(ref, () => onSelect(item.id))

    return (
        <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${(selected || show) && "bg-light-subtle"}`}
               onMouseEnter={() => setShow(true)}
               onMouseLeave={() => setShow(false)}>
            <Stack ref={ref} direction="horizontal" className="flex-grow-1" gap="2">
                <div>
                    <i className="bi bi-truck fs-3"/>
                </div>
                <div>
                    <Stack direction="vertical" className="" gap={0}>
                        <Link to={to}
                              className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <span className="text-wrap fw-semibold fs-4">{item.company}</span>
                        </Link>
                        <span className="text-wrap fs-6 fw-light">{item.name}</span>
                    </Stack>
                </div>
                <div className="ms-auto">
                    <Stack className="text-body-tertiary align-items-end justify-content-center" gap={0}>
                        <span className="text-nowrap fw-normal text-secondary">€{item.price}</span>
                        <span className="text-nowrap fw-normal text-secondary">Countries: {item.countries.length}</span>
                    </Stack>
                </div>
            </Stack>

            <div className="ms-auto">
                {(!touch || selected || selectedCount > 0) &&
                    <Button className="link-underline link-underline-opacity-0" variant="link" onClick={() => onSelect(item.id)}>
                        <span className={`bi ${selected ? "bi-check-square" : "bi-square"}`}></span>
                    </Button>
                }
            </div>
        </Stack>
    )

}
